import {
  Box,
  FieldLabel,
  FieldWrapper,
  FlexBox,
  FormField,
  FormGrid,
} from '@dixa/lib-shared-habla';
import { colors, sizes } from '@dixa/lib-shared-tokens';
import { Fragment, ReactNode } from 'react';
import { useFormContext } from 'react-hook-form';
import { Dictionary } from 'ts-essentials';

import { CustomFieldSelectAttributeOption } from 'apis/customFields';

import { ElevionCondition } from './components/elevionCondition';

const optionFieldHelpTextMap: Readonly<
  Dictionary<
    {
      readonly title: ReactNode;
      readonly description: ReactNode;
    },
    Extract<
      keyof CustomFieldSelectAttributeOption,
      'order_index' | 'label' | 'value' | 'is_deactivated'
    >
  >
> = {
  order_index: {
    title: 'Order',
    description: 'The options can be arranged to appear in a specific order.',
  },
  label: {
    title: 'Label',
    description:
      'Something that the agents can easily interpret and understand.',
  },
  value: {
    title: 'Value',
    description:
      'Unique identifier used to represent the data in API and exports.',
  },
  is_deactivated: {
    title: 'Active',
    description:
      'Deactivated options will not appear in usages of custom select attribute.',
  },
};

const helpIconText = (
  <>
    <div>
      Select attribute options that will be available to agents to select from.
    </div>

    {Object.values(optionFieldHelpTextMap).map(
      ({ title, description }, index) => (
        <Fragment key={index}>
          <br />
          <strong>{title}</strong>
          <div>{description}</div>
        </Fragment>
      ),
    )}
  </>
);

/** Represents the field for managing options of a custom select attribute. */
export const VisibilityFormField = (): JSX.Element => {
  const { formState } = useFormContext();

  return (
    <FieldWrapper
      label="Conditional visibility"
      required
      meta={{
        error: formState.errors.options
          ? formState.errors.options.root?.message?.toString() ??
            'Some options appear to be invalid'
          : undefined,
      }}
      helpIcon={{
        dark: true,
        text: helpIconText,
      }}
    >
      <Box background={colors.neutral[100]} padding="250 0" borderRadius="100">
        <FlexBox flexDirection="column" width="100%">
          <FlexBox padding="0 300" alignItems="start">
            <FlexBox flex="1 1 auto">
              <FormGrid>
                <FormField span={2}>
                  <FieldLabel required>Field</FieldLabel>
                </FormField>
                <FormField span={2}>
                  <FieldLabel required>Operator</FieldLabel>
                </FormField>
                <FormField span={2}>
                  <FieldLabel required>Value(s)</FieldLabel>
                </FormField>
              </FormGrid>
            </FlexBox>
            <Box width={sizes.spacer['500']} margin="0 0 0 200" />
          </FlexBox>

          <ElevionCondition />
        </FlexBox>
      </Box>
    </FieldWrapper>
  );
};
